import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {EconomicActivitySriInterface} from "../../../services/interface/sri/economic-activity-sri-interface";
import {ItemInfo, ItemInfoSpouse} from "../../components/ViewData";
import * as IconMaterial from "@mui/icons-material";
import {useTaxPayerStorage} from "../../../services/storage/TaxPayerStorage";
import {useFindEconomicActivation} from "../../../services/apis/apiRuc";
import NotPermissionComponent from "../../dashboard/NotPermissionComponent";
import NoRecords from "../../components/NoRecords";
import RenderEconomicActivityTree from "./RenderEconomicActivityTree";

interface Props {

}
export default function EconomicActivation({}: Props) {
    const { t } = useTranslation("global") as { t: (key: string) => string };
    const styleIcon = 'max-w-[20px] max-h-[20px]'
    const [info, setInfo] = useState<EconomicActivitySriInterface | undefined>();

    const person = useTaxPayerStorage(data => data.data)

    const {
        mutate: findEconomicActivation,
        data: successEconomicActivation,
        error: errorEconomicActivation,
        isPending: loadingEconomicActivation,
    } = useFindEconomicActivation()

    useEffect(() => {
        if (person?.accountant || person?.taxIdentificationNumber) {
            findEconomicActivation({
                identifier: person?.accountant ? person?.accountant : person?.taxIdentificationNumber,
                msj: t('economic-activity')
            })
        }
    }, [person]);

    useEffect(() => {
        if (successEconomicActivation) {
            setInfo(successEconomicActivation);
        }
    }, [successEconomicActivation]);

    return(
        <div className={'flex flex-col gap-2'}>
            <h3>{t('economic-activity')}</h3>
            <NotPermissionComponent
                className={'min-h-[50px]'}
                title={'/tax_payer/economicActivity'}
                loading={loadingEconomicActivation}
                error={errorEconomicActivation}
                component={ info ?
                    <>
                        <div className={'mt-1 custom-card py-3 px-3 flex flex-col gap-2 '}>
                            <div className={'grid grid-cols-1 gap-2'}>
                                <ItemInfo
                                    label={t('social-object')}
                                    text={info?.socialObject}
                                    icon={<IconMaterial.ConnectWithoutContactTwoTone className={styleIcon}/>}
                                />
                            </div>
                            <div className={'border border-t-1 border-t-secondary border-transparent pt-3 grid grid-cols-1 md:grid-cols-2 gap-2'}>
                                <ItemInfoSpouse
                                    label={t('code-CIIU')}
                                    text={info?.codeCIIU}
                                    className={'text-[13px]'}
                                    icon={<IconMaterial.HelpTwoTone className={styleIcon}/>}
                                />
                                <ItemInfoSpouse
                                    label={`${t('description')}`}
                                    text={info?.description}
                                    className={'text-[13px]'}
                                />
                            </div>
                        </div>
                        {info?.economicActivityFather && <RenderEconomicActivityTree economicActivity={info?.economicActivityFather}/>}
                    </> : <NoRecords/>
                }
            />
        </div>
    )
}
